import styled from 'styled-components';

export const WhyPartnerMainWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin: 4.5rem 0 4rem 0;

        @media(max-width:1023px){
            padding:1.5rem;
            margin:1.5rem 0 1.5rem 0;
        }
        @media only screen and (min-width:1024px) and (max-width:1390px){
            padding: 2rem 2rem;
        }
    `,
);

export const WhyPartnerInnerWrap = styled.div(
  props => `
        max-width:1350px;
        margin:0 auto;
        display: flex;
        width:100%;
        justify-content: space-between;

        @media(max-width:1023px){
            flex-direction: column;
        }
    `,
);

export const WhyPartnerHeadWrap = styled.div(
  props => `
        display: flex;
        flex-direction: column;

        @media(min-width:1024px){
            display: none;
        }

        @media(max-width:1024px){
            margin-bottom: 40px;
            align-items: center;
        }
    `,
);

export const WhyPartnerHeadText = styled.h2(
  props => `
        font-size:2.4rem;
        color: #2f281e;
        font-weight: 900;
        text-align: ${props.timeZone ? 'center' : ''};
    `,
);

export const WhyPartnerSubText = styled.p(
  props => `
        font-size: 1.4rem;
        color: #333333;
        padding-top:0.5rem;
    `,
);
